import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/originator');

const OriginatorFxs = {
    addOriginatorFx: domain.effect(api.originator.addOriginator),
};

export default OriginatorFxs;
